import { createContext } from 'react';

export const FasadaLingvoKunteksto = createContext(null);
export const VortaroLingvojKunteksto = createContext([41,42,66]);
export const UzantoKunteksto = createContext(null);
export const ReĝimoKunteksto = createContext(null);
export const BAZA_URL = 'https://mltv.milankolka.cz/';